import { useTranslation } from "react-i18next";

const ActivityHistoryHeader = () => {
  const { t } = useTranslation();

  return (
    <article className="table-header hidden lg:flex xl:flex 2xl:flex">
      <div
        className="data-table data-activity-image"
        style={{ justifyContent: "flex-start" }}
      >
        {t("Flux")}
      </div>
      <div className="data-table data-activity-address">{t("Address")}</div>
      <div
        className="data-table data-activity-packmat"
        style={{ justifyContent: "flex-end", textAlign: "right" }}
      >
        {t("Packmat")}
      </div>
      <div
        className="data-table data-activity-anomalies"
        style={{ justifyContent: "flex-end", textAlign: "right" }}
      >
        {t("Anomalies")}
      </div>
      <div
        className="data-table data-activity-level"
        style={{
          justifyContent: "flex-end",
          textAlign: "right",
          paddingRight: "16px",
        }}
      >
        {t("Remplissage")}
      </div>
    </article>
  );
};

export default ActivityHistoryHeader;
